/** Tipos de plano previdenciário. O valor é a sigla gravada em TP_PLANO. */
export enum TipoPlano {
  ContribuicaoDefinida = 'CD',
  ContribuicaoVariavel = 'CV',
  BeneficioDefinido = 'BD',
}

export const TIPO_PLANO_LABEL: Record<TipoPlano, string> = {
  [TipoPlano.ContribuicaoDefinida]: 'Contribuição Definida (CD)',
  [TipoPlano.ContribuicaoVariavel]: 'Contribuição Variável (CV)',
  [TipoPlano.BeneficioDefinido]: 'Benefício Definido (BD)',
};
